import { ReactComponentElement } from "react";

import { Box, useForegroundVariantColor, useTheme } from "@seneca/senekit";

type Props = {
  children: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
  className?: string;
};

export default function SidebarContentWrapperInner({
  children,
  className
}: Props) {
  const foregroundVariantColor = useForegroundVariantColor("1");

  const theme = useTheme();

  return (
    <Box
      className={className}
      backgroundColor={foregroundVariantColor}
      marginBottom="large"
      borderStyle="solid"
      borderColor={theme["neutral-xLow-content"]}
      borderWidth="xxxsmall"
      borderRadius="small"
      overflow="hidden"
      height="max-content"
    >
      {children}
    </Box>
  );
}
